"use client"

import { Copy } from "@/app/components/copy/copy"
import { ShareBoldIcon } from "@/app/icons/share-bold"
import { useCollectionPageHref } from "@/app/navigation/collection"
import { CollectionPageType } from "@/app/navigation/collection/collection-page-type"
import type { CollectionId } from "@anaconda/core/nft-collection/types"
import { Trans } from "@lingui/react/macro"
import { reatomComponent } from "@reatom/react"
import { useMolecule } from "bunshi/react"
import { useEffect, useState } from "react"
import { CollectionMoleculeReatom } from "../../store/index.reatom"

export const ShareCollection = reatomComponent(() => {
  const { collectionId } = useMolecule(CollectionMoleculeReatom)
  const absoluteUrl = useCollectionAbsoluteUrl(collectionId)

  return (
    <Copy copyValue={absoluteUrl}>
      <div className="flex items-center gap-1 text-foreground/60">
        <ShareBoldIcon />
        <Trans>Share</Trans>
      </div>
    </Copy>
  )
}, "ShareCollection")

export const useCollectionAbsoluteUrl = (collectionId: CollectionId) => {
  const relativeUrl = useCollectionPageHref(
    collectionId,
    CollectionPageType.ITEMS,
  )
  const [absoluteUrl, setAbsoluteUrl] = useState(relativeUrl)

  useEffect(() => {
    setAbsoluteUrl(`${window.location.origin}${relativeUrl}`)
  }, [relativeUrl])

  return absoluteUrl
}
